import React, { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import HorarioPDF from "./HorarioPDF";

// Mapeo de números a días de la semana
const diasSemana = {
  1: "Lunes",
  2: "Martes",
  3: "Miércoles",
  4: "Jueves",
  5: "Viernes",
};

const HorarioMemo = ({ horarios, maestros = [] }) => {
  const [filtroUsuario, setFiltroUsuario] = useState("");

  // Filtrar horarios por ID de usuario (si el usuario lo ingresa)
  const horariosFiltrados = filtroUsuario
    ? horarios.filter((h) => String(h.id_usuario) === filtroUsuario)
    : horarios;

  // Función para generar y descargar el PDF
  const handleDownload = async () => {
    let url = "";
    try {
      const blob = await pdf(
        <HorarioPDF horarios={horariosFiltrados} />
      ).toBlob();
      url = URL.createObjectURL(blob);

      const response = await fetch(url);
      const blobData = await response.blob();
      const blobUrl = window.URL.createObjectURL(blobData);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `Horario_${filtroUsuario || "todos"}.pdf`;
      link.click();
    } catch (error) {
      console.error("Error al descargar el PDF:", error);
    } finally {
      if (url) URL.revokeObjectURL(url);
    }
  };

  return (
    <div className="horario-memo">
      <div className="filter-container">
        <select
          value={filtroUsuario}
          onChange={(e) => setFiltroUsuario(e.target.value)}
          className="filter-input"
        >
          <option value="">Seleccione un profesor</option>
          {maestros.length > 0 ? (
            maestros.map((maestro) => (
              <option key={maestro.id} value={maestro.id}>
                {`${maestro.nombre} ${maestro.apellido_paterno} ${maestro.apellido_materno}`}
              </option>
            ))
          ) : (
            <option value="">No hay maestros disponibles</option>
          )}
        </select>

        <button onClick={handleDownload} className="download-btn">
          Descargar PDF
        </button>
      </div>
    </div>
  );
};

export default HorarioMemo;
